/*** TRIGGER ANIMATION BY ES ***/

declare var gsap: any;
declare var ScrollTrigger: any;
gsap.registerPlugin(ScrollTrigger);

interface ReferenceElement<T> {
    selector?: string;
    target?: Array<T> | null;
}

interface TriggerConfig {
    media?: number;
    mobile?: DeviceConfig;
    desktop?: DeviceConfig;
}

interface DeviceConfig {
    from?: any;
    to?: any;
}

const DEFAULT_TRIGGER = {
    start: 'top bottom-=50px'
}

const DEFAULT_ANIMATION = {
    initial: {
        translateY: 30,
        opacity: 0
    },
    final: {
        duration: 0.8,
        translateY: 0,
        opacity: 1
    }
}

const DEFAULT_CONFIG = {
    media: 768
}


export default class TriggerAnimation {
    elements: ReferenceElement<any>;
    config: TriggerConfig;

    constructor(selector: string, config?: TriggerConfig) {
        this.elements = { selector, target: gsap.utils.toArray(selector) };
        this.config = { ...DEFAULT_CONFIG, ...config };

        this.setInitialState();
    }

    setInitialState() {
        let { mobile, desktop, media } = this.config;
        let initialMobile = mobile?.from || DEFAULT_ANIMATION.initial

        if ("desktop" in this.config) {
            let initialDesktop = desktop?.from || DEFAULT_ANIMATION.initial

            const myFunction = (x: any) => {
                if (x.matches) this.setValues(initialDesktop);
                else this.setValues(initialMobile);
            }

            const mmObj = window.matchMedia(`(min-width: ${media}px)`)
            myFunction(mmObj);
            mmObj.addListener(myFunction);
        }
        else {
            this.setValues(initialMobile);
        }
    }

    setValues(initialValues: any) {
        let { target } = this.elements
        target?.forEach(item => {
            gsap.set(item, { ...initialValues })
        })
    }

    // DISPARA LA ANIMACION DEL ELEMENTO
    triggerAnimation() {
        let { mobile, desktop, media } = this.config;
        let finalMobile = { ...DEFAULT_ANIMATION.final, ...mobile?.to }

        if ("desktop" in this.config) {
            let finalDesktop = { ...DEFAULT_ANIMATION.final, ...desktop?.to }

            const myFunction = (x: any) => {
                if (x.matches) this.animate(finalDesktop);
                else this.animate(finalMobile);
            }

            const mmObj = window.matchMedia(`(min-width: ${media}px)`)
            myFunction(mmObj);
            mmObj.addListener(myFunction);
        }
        else {
            this.animate(finalMobile)
        }
    }

    animate(animationConfig: any) {
        let { target } = this.elements;
        let { scrollTrigger: customST, ...gsapConfig } = animationConfig

        if (customST && customST.trigger) {
            gsap.to(target, {
                ...gsapConfig,
                scrollTrigger: {
                    ...DEFAULT_TRIGGER,
                    ...customST
                }
            });
        }
        else {
            target?.forEach(item => {
                gsap.to(item, {
                    ...gsapConfig,
                    scrollTrigger: {
                        ...DEFAULT_TRIGGER,
                        ...customST,
                        trigger: item
                    }
                })
            })
        }
    }
}